import { connect } from "react-redux";
import { useEffect, useState } from "react";

import errorMessages from "../../constant/errorMessages";
import defaultValues from "../../constant/defaultValues";

import { includes, isEmpty, map, size } from "lodash";
import { getCityList, getCityListBySerachVal, getCountryList } from "../../actions/defaultDataAction";

import Choosefile from "../Choosefile";
import InputField from "../InputField";
import DropDown from "../DropDown";
import ButtonAdminpanel from "../ButtonAdminpanel";

// import NoUser from "../../images/viewProfileContact_img.svg";
import uploadPhotos from "../../images/Company-logo.svg";
import { useParams } from "react-router-dom";
import { getPromotionMediaInfo, submitPromotionForm } from "../../actions/updateProfileAction";
import { showSuccessMessage } from "../../utils/common";

import regExpressions from "../../constant/regExpressions";
import { hideLoading, showLoading } from "../../actions/loaderAction";
import { useAuth } from "../../AuthProvider";


const PromotionMediaInfo = (props) => {

    const { id } = useParams();

    const { IGNORE_EMAILS, IMAGE_PATH, EMAIL_FIELD_MAX_LENGTH } = defaultValues;
    const ALLOWED_TYPES = ['image/jpeg', 'image/png', 'image/jpg'];
    const MAX_FILE_SIZE = 2 * 1024 * 1024;
    const [previewImg, setPreviewImg] = useState(null);
    const [countryList, setCountryList] = useState([]);
    const [selectedCountry, setSelectedCountry] = useState(null);
    const [cityList, setCityList] = useState([]);
    const [selectedCity, setSelectedCity] = useState(null);
    const [errors, setErrors] = useState({});
    const [formData, setFormData] = useState({
        designation: "",
        email: "",
        country_id: null,
        city_id: null,
        contactImg: null,
        member_id: id,
        full_name: ""
    });

    const { isViewer, isInqUser } = useAuth();

    //console.log("company info === ", props.company_info);

    const handleImgChange = (e) => {
        const { name, files } = e.target;

        let errObj = { ...errors };

        if (files.length > 0) {
            const file = files[0];
            if (!ALLOWED_TYPES.includes(file.type)) {
                errObj.contactImg = "The file must be a file of type jpg, png, jpeg";
            } else if (file.size > MAX_FILE_SIZE) {
                errObj.contactImg = "The file must be less than or equal to 2 MB";
            } else {
                errObj.contactImg = "";
            }

            setErrors(errObj);
        }

        if (errObj.contactImg === "" || errObj.contactImg === null) {
            setPreviewImg(URL.createObjectURL(files[0]));
            setFormData((prev) => {
                return {
                    ...prev,
                    contactImg: files[0]
                }
            });
        } else {
            e.target.value = '';
            setPreviewImg(null);
            setFormData((prev) => {
                return {
                    ...prev,
                    contactImg: null
                }
            });
        }



    }

    const handleCountryChange = (val) => {
        setSelectedCountry(val);
        setSelectedCity(null);
        if (val) {
            setFormData((prev) => {
                return {
                    ...prev,
                    country_id: val.value
                }
            });
            renderCityList(val.value);
        }
    }

    const renderCityList = async (countryId) => {
        await props.getCityList(countryId).then((data) => {
            if (!isEmpty(data)) {
                const cityOptions = data.map((val) => {
                    return {
                        label: val.name + (val.state_code ? " (" + val.state_code + ")" : ""),
                        value: val.id
                    }
                });
                setCityList(cityOptions);
            }
        }).catch((err) => {
            console.log("Error in renderCityList == ", err);
        })
    }

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => {
            return {
                ...prev,
                [name]: value
            }
        })
    }

    const handleInputChange = (newValue, city_id = 0, country_id = 0) => {
        let countryId = 0;
        if (selectedCountry && selectedCountry.value > 0) {
            countryId = selectedCountry.value;
        } else if (country_id > 0) {
            countryId = country_id;
        }


        if (isEmpty(newValue) && countryId > 0) {
            setCityList([]);
            renderCityList(countryId);
        }

        if (!isEmpty(newValue) && countryId > 0) {
            if (size(newValue) >= 3) {
                setCityList([]);
                props.getCityListBySerachVal(newValue, countryId).then(response => {
                    if (response && size(response) > 0) {
                        const cityOptions = map(response, (v) => ({
                            label: v.name + (v.state_code ? " (" + v.state_code + ")" : ""),
                            value: v.id,
                            txt: v.name + (v.state_code ? "(" + v.state_code + ")" : ""),
                        }));
                        setCityList(cityOptions);
                        if (city_id > 0) {

                            const cityOption = cityOptions.find((val) => val.value === city_id);
                            setSelectedCity(cityOption);
                        }
                    } else {
                        setCityList([]);
                        renderCityList(countryId);
                    }
                });
            }
        }
    };

    const handleCityChange = (val) => {
        setSelectedCity(val);
        if (val) {
            setFormData((prev) => {
                return {
                    ...prev,
                    city_id: val.value
                }
            });
        }
    }

    const validateDesignation = (val) => {
        if (isEmpty(val)) {
            return errorMessages.FIELD_REQUIRED
        } else if (val.length > 100) {
            return errorMessages.MAX_LENGTH_100_EXCEEDED;
        } else {
            const regExp = /^[A-Za-z](?:[A-Za-z0-9 ,&.-/]*[A-Za-z0-9])?(?:\s*[-&/]\s*[A-Za-z0-9]+)*(?:\s*)?$/;
            const check = regExp.test(val);
            if (check === false) {
                return errorMessages.IN_VALID_FIELD_FORMAT;
            } else {
                return "";
            }
        }
    }

    const validateEmail = (val) => {
        if (isEmpty(val)) {
            return errorMessages.FIELD_REQUIRED;
        } else if (val.length > EMAIL_FIELD_MAX_LENGTH) {
            return errorMessages.MAX_LENGTH_150_EXCEEDED
        } else {
            const currentEmail = val.split('@')[1];
            const regExp = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
            const check = regExp.test(val);
            if (includes(IGNORE_EMAILS, currentEmail)) {
                return errorMessages.IN_VALID_FIELD_FORMAT;
            } else if (!check) {
                return errorMessages.IN_VALID_FIELD_FORMAT;
            } else {
                return "";
            }
        }
    }

    const validateFullName = (val) => {
        if (isEmpty(val)) {
            return errorMessages.FIELD_REQUIRED;
        } else if (val.length > 50) {
            return errorMessages.MAX_LENGTH_EXCEEDED
        } else {
            const regExp = regExpressions.name;
            const check = regExp.test(val);
            if (check === false) {
                return errorMessages.IN_VALID_FIELD_FORMAT;
            }
            else {
                return "";
            }
        }
    }

    const handleFocusOut = (e) => {
        const { name, value } = e.target;
        let errObj = { ...errors };
        if (name === "designation") {
            let d = validateDesignation(value);
            errObj.designation = d;
        }
        if (name === "email") {
            let emil = validateEmail(value);
            errObj.email = emil;
        }
        if (name === "full_name") {
            let fullName = validateFullName(value);
            errObj.full_name = fullName;
        }
        setErrors(errObj);
    }

    const validation = () => {
        let errObj = { ...errors };
        let d = validateDesignation(formData.designation);
        errObj.designation = d;

        let eml = validateEmail(formData.email);
        errObj.email = eml;

        let fn = validateFullName(formData.full_name);
        errObj.full_name = fn;

        if (formData.country_id > 0) {
            errObj.country_id = "";
        } else {
            errObj.country_id = errorMessages.FIELD_REQUIRED;
        }
        if ((formData.contactImg === null || formData.contactImg === undefined) && (previewImg == null || previewImg == "")) {
            errObj.contactImg = errorMessages.FIELD_REQUIRED;
        } else {
            errObj.contactImg = "";
        }

        setErrors(errObj);

        let isError = Object.keys(errObj).filter(key => errObj[key] !== null && errObj[key] !== undefined && errObj[key] !== "").length;
        if (isError > 0) {
            return false;
        } else {
            return true;
        }
        //return Object.keys(errObj).filter(key => errObj[key] === null || errObj[key] === undefined || errObj[key] === "").length <= 0;
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        let er = { ...errors };
        if (await validation()) {
            // props.showLoading();
            await props.submitPromotionForm(formData).then((response) => {
                if (response == true) {
                    showSuccessMessage("Update profile successfully...");
                    setTimeout(async () => {
                        await fetchContactInfo();
                    }, 2000);
                } else {
                    setErrors({});
                    if (!isEmpty(response.errors)) {
                        if (response.errors.full_name) {
                            er.full_name = response.errors.full_name[0];
                        }
                        if (response.errors.email) {
                            er.email = response.errors.email[0];
                        }
                        if (response.errors.designation) {
                            er.designation = response.errors.designation[0];
                        }
                        if (response.errors.country_id) {
                            er.country_id = response.errors.country_id[0];
                        }
                        if (response.errors.contactImg) {
                            er.contactImg = response.errors.contactImg[0];
                        }
                        setErrors(er);
                    }
                }
            }).catch((err) => {
                console.log("Error >>> ", err);
            })
            // props.hideLoading();
        }
    }

    const fetchDefaultData = async () => {

        /** Get Countries */
        await props.getCountryList().then((data) => {
            if (!isEmpty(data)) {
                const countryOptions = data.map((cval) => {
                    return {
                        label: cval.name,
                        value: cval.id
                    }
                });
                setCountryList(countryOptions);
            } else {
                setCountryList([]);
            }

        }).catch((err) => {
            console.log("Error in getCountryList == ", err);
        })
    }

    const fetchContactInfo = async () => {
        props.getPromotionMediaInfo(id).then((data) => {
            if (data) {
                setFormData((prev) => {
                    return {
                        ...prev,
                        country_id: data.country_id,
                        email: data.email,
                        designation: data.designation,
                        city_id: data.city_id,
                        contactImg: data.promotion_img,
                        member_id: id,
                        full_name: data.full_name
                    }
                });

                let city = 0;
                let city_name = "";
                if (data.city_id > 0) {
                    city = data.city_id;
                    city_name = (data.promotion_city && data.promotion_city.name) ? data.promotion_city.name : "";
                } else {
                    city = 0;
                    city_name = "";
                }


                const countryOption = countryList.find(
                    (option) => option.value === data.country_id
                );
                setSelectedCountry(countryOption);
                setTimeout(() => { handleInputChange(city_name, city, data.country_id); }, 500);

                setPreviewImg(IMAGE_PATH.BASE_URL + data.promotion_img);
            }
        }).catch((err) => {
            console.log("Error == ", err);
        })

    };



    // useEffect(() => {
    //     if (size(countryList) > 0) {
    //         props.getPromotionMediaInfo(id).then((data) => {
    //             if (data) {
    //                 setFormData((prev) => {
    //                     return {
    //                         ...prev,
    //                         country_id: data.country_id,
    //                         email: data.email,
    //                         designation: data.designation,
    //                         city_id: data.city_id,
    //                         contactImg: data.promotion_img,
    //                         full_name: data.full_name
    //                     }
    //                 });

    //                 let city = 0;
    //                 let city_name = "";
    //                 if (data.city_id > 0) {
    //                     city = data.city_id;
    //                     city_name = (data.promotion_city && data.promotion_city.name) ? data.promotion_city.name : "";
    //                 } else {
    //                     city = 0;
    //                     city_name = "";
    //                 }


    //                 const countryOption = countryList.find(
    //                     (option) => option.value === data.country_id
    //                 );
    //                 setSelectedCountry(countryOption);
    //                 setTimeout(() => { handleInputChange(city_name, city, data.country_id); }, 500);

    //                 setPreviewImg(IMAGE_PATH.BASE_URL + data.promotion_img);
    //             }
    //         }).catch((err) => {
    //             console.log("Error == ", err);
    //         })
    //     }
    // }, [countryList]);
    useEffect(() => {
        fetchDefaultData();
    }, []);


    useEffect(() => {
        if (countryList.length > 0 && id) {
            fetchContactInfo();
        }
    }, [countryList, id]);


    const styleError = {
        display: 'block',
    };

    return (
        <div>
            <h3 className='company-info-text'>Promotion Media Info</h3>
            <div className="p-4 card-shadow bg-white rounded">
                <form className="" onSubmit={handleSubmit}>
                    <div className=" fv-plugins-icon-container">
                        <div>
                            <div className='d-flex justify-content-between align-items-center border-bottom pb-2'>
                                <h4 className='head-office-text'>Promotion Media Info</h4>
                            </div>
                            <div className="row">
                                {/* <div className="col-md-6 py-2"> */}

                                {/* </div> */}
                                <div className="col-md-6 py-2">
                                    <label className='profile-text'>Full Name <span className="text-danger">*</span></label>
                                    <InputField name="full_name" placeholder={"Enter your full name"}
                                        className={"input-error-border"} onChange={handleChange} onBlur={handleFocusOut} value={formData.full_name} disabled={props.disableProfile || isViewer} autoComplete="off" />
                                    {errors.full_name && <span className="company-required" style={styleError}>{errors.full_name}</span>}
                                </div>
                                <div className="col-md-6 py-2">
                                    <label className='profile-text'>Designation <span className="text-danger">*</span></label>
                                    <InputField name="designation" placeholder={"Enter your designation"}
                                        className={"input-error-border"} onChange={handleChange} onBlur={handleFocusOut} value={formData.designation} disabled={props.disableProfile || isViewer} autoComplete="off" />
                                    {errors.designation && <span className="company-required" style={styleError}>{errors.designation}</span>}
                                </div>
                                <div className="col-md-6 py-2">
                                    <label className='profile-text'>Email <span className="text-danger">*</span></label>
                                    <InputField name="email" placeholder={"Enter your email"}
                                        className={"input-error-border"} onChange={handleChange} onBlur={handleFocusOut} value={formData.email} disabled={props.disableProfile || isViewer} autoComplete="off" />
                                    {errors.email && <span className="company-required" style={styleError}>{errors.email}</span>}
                                </div>
                                <div className="col-md-6 py-2">
                                    <label className='profile-text'>Badge <span className="text-danger">*</span></label>
                                    <InputField name="badge" placeholder={"Badge"} value={props.company_info.badge}
                                        className={"input-error-border"} disabled={true} autoComplete="off" />
                                </div>
                                <div className="col-md-6 py-2">
                                    <label className='profile-text'>Country <span className="text-danger">*</span></label>
                                    <DropDown
                                        placeholder={"Select country"}
                                        className={"input-error-border"}
                                        options={countryList}
                                        value={selectedCountry}
                                        onChange={handleCountryChange}
                                        isDisabled={props.disableProfile || isViewer}
                                    ></DropDown>
                                    {errors.country_id && <span className="company-required" style={styleError}>{errors.country_id}</span>}
                                </div>
                                <div className="col-md-6 py-2">
                                    <label className='profile-text'>City </label>
                                    <DropDown
                                        placeholder={"Select city"}
                                        className={"input-error-border"}
                                        options={cityList}
                                        value={selectedCity}
                                        onChange={handleCityChange}
                                        isDisabled={props.disableProfile || isViewer}
                                        onInputChange={handleInputChange}
                                    ></DropDown>
                                </div>
                                <div className="col-xxl-6 col-xl-6 py-3">
                                    <div className="row">
                                        <div className='col-xxl-9 col-xl-9 col-md-9'>

                                            <label className='profile-text'> Upload Photo <span className="text-danger">*</span>
                                            </label>
                                            <Choosefile
                                                className={`form-control choose-pdf`}
                                                type="file"
                                                accept="image/jpeg, image/png, image/jpg"
                                                onChange={handleImgChange}
                                                //name={`images#@${idx}`}
                                                //id={`images#@${idx}`}
                                                disabled={props.disableProfile || isViewer}
                                            />
                                            {errors.contactImg && <span className="company-required" style={styleError}>{errors.contactImg}</span>}
                                            <p className='upload-info'>Allowed JPEG, JPG or PNG. Max size of 2 MB</p>
                                        </div>

                                        <div className='col-xxl-3 col-xl-3 col-md-3'>
                                            {/* <div className="view-profile-contact-img"> */}
                                            <div className="d-flex upload-img contact-upload-image">

                                                {previewImg ? <img src={previewImg} alt='no-img' id="pdf-img" /> : <img src={uploadPhotos} alt='no-img' id="pdf-img" className='contactUploadImg' />}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>

                        </div>
                    </div>
                    {(!props.disableProfile && !isViewer && !isInqUser) && (
                        <div className='profile-btn mt-5 border-top'>
                            <ButtonAdminpanel type="submit" className="mt-4 btn-regi" disabled={props.disableProfile || isViewer || isInqUser}> Save Changes</ButtonAdminpanel>
                        </div>
                    )}

                </form>
            </div>
        </div>)
}

const mapStateToProps = (state) => {
    return {
        company_info: state.update.updateProfile,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        getCountryList: () => dispatch(getCountryList()),
        getCityList: (countryId) => dispatch(getCityList(countryId)),
        getCityListBySerachVal: (searchTxt, countryId) => dispatch(getCityListBySerachVal(searchTxt, countryId)),
        submitPromotionForm: (formData) => dispatch(submitPromotionForm(formData)),
        getPromotionMediaInfo: (member_id) => dispatch(getPromotionMediaInfo(member_id)),
        showLoading: () => dispatch(showLoading()),
        hideLoading: () => dispatch(hideLoading())
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(PromotionMediaInfo);